import type { ButtonHTMLAttributes, Ref } from 'react'

import IconButton, { type IconButtonProps } from 'js/components/IconButton'
import cx from 'js/lib/helpers/cx'

import styles from './NavigationAction.module.css'

type NavigationActionProps = {
    tooltip: IconButtonProps['tooltip']
    ref?: Ref<HTMLButtonElement>
} & ButtonHTMLAttributes<HTMLButtonElement>

const NavigationAction = ({
    children,
    tooltip,
    className,
    'aria-label': ariaLabel,
    ref,
    ...rest
}: NavigationActionProps) => {
    const headerMain = getComputedStyle(document.documentElement)
        .getPropertyValue('--ref-palette-header-main')
        .trim()
    const tooltipTheme = headerMain !== '#ffffff' ? 'header' : undefined
    const accessibleLabel = ariaLabel ?? tooltip

    return (
        <IconButton
            ref={ref}
            className={cx(styles.wrapper, className)}
            bgOffset="sm"
            tooltip={tooltip}
            tooltipProps={{
                sideOffset: 4,
                side: 'bottom',
                theme: tooltipTheme,
            }}
            aria-label={accessibleLabel}
            {...rest}
        >
            {children}
        </IconButton>
    )
}

export default NavigationAction
